// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q1k7","controls":"styles_controls__3Is4k","charLimit":"styles_charLimit__1dGBo","input":"styles_input__1SXpR","send":"styles_send__2N0LG"};